<template>
  <div name="Home" class="text-center align-center" >

    <p class="display-3 font-weight-light primary--text" bold>
      Herzlich Willkommen!
    </p>

    <p>
      Wir freuen uns, Sie auf der Homepage des Alten- und Pflegeheims Frankenburg begr&uuml;&szlig;en zu d&uuml;rfen.
    </p>

    <Aktuelles/>

    <Spruch/>
  </div>
</template>

<script>
  export default {
    name: 'Home',

    components: {
      Aktuelles: () => import('@/components/home/Aktuelles'),
      Spruch: () => import('@/components/home/Spruch'),
    },
  }
</script>